import { AfterViewInit, Directive, ElementRef } from '@angular/core';

@Directive({ selector: 'img' })
export class LazyLoadDirective implements AfterViewInit {

	constructor(private el: ElementRef<HTMLImageElement>) {}

	ngAfterViewInit(): void {
		const nativeElement = this.el.nativeElement;
		if (!nativeElement) return;
		if (nativeElement.getAttribute('loading') === 'eager') return;
		if (nativeElement.hasAttribute('data-eager')) return;
		const supports = 'loading' in HTMLImageElement.prototype;
		if (supports) {
			nativeElement.setAttribute('loading', 'lazy');
		}
	}
}
